__turbopack_context__.v({
  "amountHeader": "lotazG_amountHeader",
  "amountListItem": "lotazG_amountListItem",
  "amountListItemContent": "lotazG_amountListItemContent",
  "amountRadio": "lotazG_amountRadio",
  "amounts": "lotazG_amounts",
  "collapsibleContent": "lotazG_collapsibleContent",
  "fullAmountSummary": "lotazG_fullAmountSummary",
  "fullOnlySection": "lotazG_fullOnlySection",
  "paymentAmountDetails": "lotazG_paymentAmountDetails",
  "slideDown": "lotazG_slideDown",
  "slideUp": "lotazG_slideUp",
  "summaryAmount": "lotazG_summaryAmount",
  "summaryRow": "lotazG_summaryRow",
  "summaryTitle": "lotazG_summaryTitle",
});
